import { useStore } from '@/hooks/useStore';
import { useLocation, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { InputOTP, InputOTPSlot } from '@/components/common/Input';
import { Button } from '@/components/common/Button';
import bannerImg from '@/assets/images/pngs/banner-login.png';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@/configs/constants';
import { toastify } from '@/utils/toastify';
import { flowResult } from 'mobx';
import { startRegistration } from '@simplewebauthn/browser';
import { handleLongText } from '@/utils/utils';

export default observer(function InputOTPPage() {
    // store
    const {
        authStore: { sentOTP, verifyOTP, generateResistration }
    } = useStore();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { email, type } = location.state || {};
    const [otp, setOtp] = useState<string>('');
    const [timeDown, setTimeDown] = useState<number>(60);
    useEffect(() => {
        if (timeDown <= 0) return;
        const timer = setInterval(() => {
            setTimeDown(prevTime => prevTime - 1);
        }, 1000);
        return () => clearInterval(timer);
    }, [timeDown]);

    const handleSubmit = async () => {
        const body = {
            email: email,
            code: otp
        };
        const challenge = await flowResult(generateResistration({ email: email }));
        console.log('challenge', challenge);
        const dataRegistration = await startRegistration({ optionsJSON: challenge });
        console.log('dataRegistration', dataRegistration);
        const res = await flowResult(verifyOTP(body));
        if (res) {
            navigate(ROUTES.finishSignUp.href, { state: { email: email, type: type, expectedChallenge: challenge.challenge, dataRegistration: dataRegistration } });
        }
    };
    const goBack = () => {
        navigate(ROUTES.inputEmail.href, { state: { email: email, type: type } });
    };
    const sendAgain = async () => {
        const body = {
            email: email
        };
        const res = await flowResult(sentOTP(body));
        if (res) {
            toastify('success', t('text.otpSent'));
            setTimeDown(60);
        }
    };

    return (
        <div className='w-screen h-screen '>
            <div className='mx-auto flex w-full h-full flex-col justify-start items-center'>
                <ArrowLeft onClick={goBack} size={24} className='absolute top-[24px] left-[24px] text-white cursor-pointer' />
                <img src={bannerImg} alt='bannerImg' className='w-full h-[30%]' />
                <div className='w-full text-center px-[24px] mt-[-32px] rounded-t-[24px] bg-white pt-[32px] space-y-[24px]'>
                    <p className='text-[27px] font-bold px-[32px]'>{t('text.inputOtp')}</p>
                    <div className='text-[15px] font-normal pb-8 text-textAccountType'>
                        <p className='font-bold'>{handleLongText(email, 5)}</p>
                        <p className=''>{t('text.desInputOtp')}</p>
                    </div>
                    <div>
                        <InputOTP
                            onChange={text => setOtp(text)}
                            maxLength={6}
                            containerClassName='w-full flex  justify-around'
                            value={otp}
                        >
                            <InputOTPSlot index={0} />
                            <InputOTPSlot index={1} />
                            <InputOTPSlot index={2} />
                            <InputOTPSlot index={3} />
                            <InputOTPSlot index={4} />
                            <InputOTPSlot index={5} />
                        </InputOTP>
                        <button onClick={sendAgain} disabled={timeDown > 0} className='text-textBlue text-[15px] mt-[16px] disabled:text-textAccountName'>{t('text.tryAfter', { sec: timeDown })}</button>
                    </div>

                    <Button
                        variant='main'
                        className='w-full h-[48px] rounded-[10px]'
                        onClick={handleSubmit}
                        disabled={otp.length !== 6}
                    >
                        {t('text.sent')}
                    </Button>
                </div>
            </div>
        </div>
    );
});
